import { memo } from 'react'
import { SearchResultRowBtn } from '@tabeeb/modules/contentSharings/constants/enums'
import { Button } from '@collaborate-health/uikit'

interface SearchResultButtonProps {
  button: string
  handleButtonClick: () => void
}

const SearchResultButton: React.FC<SearchResultButtonProps> = ({ button, handleButtonClick }) => {
  return button === SearchResultRowBtn.Remove ? (
    <Button onClick={handleButtonClick} variant='contained' color='primary' size='small'>
      {button}
    </Button>
  ) : (
    <Button onClick={handleButtonClick} variant='outlined' size='small'>
      {button}
    </Button>
  )
}

export default memo(SearchResultButton)

